import React, {
  createContext,
  useContext,
  useEffect,
  useReducer,
  useCallback,
} from "react";
import { collection, doc, getDoc, onSnapshot, query } from "firebase/firestore";
import { db } from "../Firebase_Config/firebaseConfig";
import reducer from "../reducer/blogReducer";

const AppContext = createContext();

const initialState = {
  isLoading: false,
  isError: false,
  blogs: [],
  isSingleLoading: false,
  singleBlog: {},
};

const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  // Fetch all posts (real-time)
  const getPosts = useCallback(() => {
    const postsCollectionRef = collection(db, "blogPosts"); // move here

    dispatch({ type: "SET_LOADING" });

    const unsubscribe = onSnapshot(
      query(postsCollectionRef),
      (snapshot) => {
        let blogList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        blogList = blogList.filter(
          (b) => b.status?.toLowerCase().trim() === "approved"
        );

        blogList = blogList.filter(
          (b, idx, self) => idx === self.findIndex((x) => x.id === b.id)
        );

        blogList.sort((a, b) => {
          const prioA = a.priority ?? 9999;
          const prioB = b.priority ?? 9999;
          if (prioA !== prioB) return prioA - prioB;
          return (
            (b.publishDate?.toDate?.() ?? new Date(b.publishDate)) -
            (a.publishDate?.toDate?.() ?? new Date(a.publishDate))
          );
        });

        dispatch({ type: "MY_BLOG_DATA", payload: blogList });
      },
      (error) => {
        console.error("Failed to fetch blogs:", error);
        dispatch({ type: "MY_BLOG_ERROR" });
      }
    );

    return unsubscribe;
  }, []); // empty dependency array

  // Fetch a single blog by ID
  const getSinglePost = async (ID) => {
    dispatch({ type: "SET_SINGLE_LOADING" });
    try {
      const docRef = doc(db, "blogPosts", ID);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        dispatch({
          type: "MY_SINGLE_BLOG_DATA",
          payload: { id: docSnap.id, ...docSnap.data() },
        });
      } else {
        dispatch({ type: "MY_SINGLE_BLOG_ERROR" });
      }
    } catch (error) {
      console.error("Failed to fetch single blog:", error);
      dispatch({ type: "MY_SINGLE_BLOG_ERROR" });
    }
  };

  // Initialize listener on mount
  useEffect(() => {
    const unsubscribe = getPosts();
    return () => unsubscribe();
  }, [getPosts]); // now getPosts is stable

  return (
    <AppContext.Provider
      value={{
        ...state,
        getSinglePost,
        refetchPosts: getPosts, // manual refresh option
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

const useBlogContext = () => useContext(AppContext);

export { AppProvider, AppContext, useBlogContext };
